import React from "react";
import TextField from "../../components/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";

export default function PasswordField(props) {
  return (
    <TextField
      variant="outlined"
      fullWidth
      // className={props.className}
      label={props.label}
      type={props.show ? "text" : "password"}
      value={props.value}
      onChange={props.onChange}
      autoComplete={props.autoComplete}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={props.onShowClick}
              onMouseDown={props.onShowMouseDown}
            >
              {props.show ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}
